import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { BaseItem } from 'Types/item'
import { PartnerContract, TContactFacesByPartner, TContractMeta, TCreateContract } from 'Pages/pp'
import { Callback } from 'Src/types/utilTypes'
import { MODAL_NAME } from 'Constants/ModalName'

export type ContractsRegistryState = {
	data: ResponseCatalog<PartnerContract, TContractMeta>
	requestParams: RequestParams
	filtersTranslate: Record<string, BaseItem | BaseItem[]>
	loading: boolean
	contactFaces: TContactFacesByPartner[]
}

const initialState: ContractsRegistryState = {
	data: new ResponseCatalog<PartnerContract, TContractMeta>(),
	requestParams: new RequestParams(1, 30),
	loading: false,
	filtersTranslate: {},
	contactFaces: [],
}

export namespace ContractsRegistryNS {
	export type GetList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetList = PayloadAction<ResponseCatalog<PartnerContract, TContractMeta>>
	export type SetIsLoading = PayloadAction<boolean>
	export type SetFiltersTranslate = PayloadAction<ContractsRegistryState['filtersTranslate']>
	export type CreateContract = PayloadAction<TCreateContract>
	export type DeleteContract = PayloadAction<number>
	export type UpdateContract = PayloadAction<{
		id: number
		data: TCreateContract
		modalForClose?: MODAL_NAME
		set_status?: string
		callback?: Callback
	}>
	export type MassUpdateContract = PayloadAction<{
		params: Record<string, unknown>
		data: Partial<PartnerContract>
	}>
	export type MassUpdateContractFinished = PayloadAction<{ ids: number[] }>
	export type GetFaces = PayloadAction<number>
	export type SetFaces = PayloadAction<TContactFacesByPartner[]>
	export type createAstPartnerRequest = PayloadAction<{
		partner_id: number
		contract_id: number
		modalForClose?: MODAL_NAME
		callback?: Callback
	}>
	export type GetLimitReminder = PayloadAction<number>
	export type DownloadLimitDocument = PayloadAction<{ id: number }>
}

export const contractsRegistrySlice = createSlice({
	name: 'contractsRegistry',
	initialState,
	reducers: {
		getList: (state, action: ContractsRegistryNS.GetList) => {
			state.loading = true
		},
		setList: (state, action: ContractsRegistryNS.SetList) => {
			state.data = action.payload
			state.loading = false
		},
		clearList: (state) => {
			state.data = new ResponseCatalog<PartnerContract, TContractMeta>()
			state.requestParams = new RequestParams()
			state.filtersTranslate = {}
		},
		setRequestParams: (state, action: ContractsRegistryNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		setIsLoading: (state, action: ContractsRegistryNS.SetIsLoading) => {
			state.loading = action.payload
		},
		setFiltersTranslate: (state, action: ContractsRegistryNS.SetFiltersTranslate) => {
			state.filtersTranslate = { ...state.filtersTranslate, ...action.payload }
		},
		createContract: (state, action: ContractsRegistryNS.CreateContract) => {},
		deleteContract: (state, action: ContractsRegistryNS.DeleteContract) => {},
		updateContract: (state, action: ContractsRegistryNS.UpdateContract) => {},
		massUpdateContract: (state, action: ContractsRegistryNS.MassUpdateContract) => {},
		massUpdateContractFinished: (
			state,
			action: ContractsRegistryNS.MassUpdateContractFinished
		) => {},
		getFaces: (state, action: ContractsRegistryNS.GetFaces) => {},
		setFaces: (state, action: ContractsRegistryNS.SetFaces) => {
			state.contactFaces = action.payload
		},
		clearFaces: (state) => {
			state.contactFaces = []
		},
		createAstPartnerRequest: (state, action: ContractsRegistryNS.createAstPartnerRequest) => {},
		getLimitReminder: (state, action: ContractsRegistryNS.GetLimitReminder) => {},
		downloadDocument: (state, action: ContractsRegistryNS.DownloadLimitDocument) => {},
	},
})
